import useScreenDesign from "@/Core/utils/hooks/useScreenDesign";
import { useGlobalOpenNotice } from "@/store/commonStore";
import { useMessageCount, useNoticeMessage } from "@/store/message";
import useDialogManager from "@/utils/useDialogManager";
import React, { useEffect } from "react";

/**处理消息已读 */
const HandleNoticeRead = () => {
    const [openNotice] = useGlobalOpenNotice();
    //通知消息列表
    const { data: noticeData, mutate: noticeMutate } = useNoticeMessage({ pageNum: 1, pageSize: 50 })
    const { data: countData, mutate: countMutate } = useMessageCount()
    const { openDialogNotice } = useDialogManager();
    const mobile = useScreenDesign();
    //处理通知消息
    useEffect(() => {
        // console.log('处理通知消息')
        if (openNotice) {
            if (noticeData && noticeData?.records) {
                for (const record of noticeData?.records) {
                    record.alreadyRead = true
                }
                noticeMutate()
                if(countData) {
                    countData.unread = 0
                    countMutate(countData, { revalidate: false })
                }
            }
            if (mobile) {
                openDialogNotice()
            }
        }
    }, [openNotice])

    return (<></>)
}
export default HandleNoticeRead